import { render } from "./BsModal.vue?vue&type=template&id=1997437a"
import script from "./BsModal.vue?vue&type=script&lang=js"
export * from "./BsModal.vue?vue&type=script&lang=js"

import "./BsModal.vue?vue&type=style&index=0&id=1997437a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__